import { render } from "./FreeTierUsagePill.vue?vue&type=template&id=4b0c2bca&scoped=true"
import script from "./FreeTierUsagePill.vue?vue&type=script&lang=js"
export * from "./FreeTierUsagePill.vue?vue&type=script&lang=js"

import "./FreeTierUsagePill.vue?vue&type=style&index=0&id=4b0c2bca&scoped=true&lang=css"

import exportComponent from "C:\\Users\\darca\\dev\\spanish-ai\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b0c2bca"]])

export default __exports__